import styled from 'styled-components';

import { fontFamilySecondary, color4, colorWhite2 } from 'styles';

export const Title = styled.h3`
  font-family: ${fontFamilySecondary};
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const LinksList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LinksListItem = styled.li`
  margin: 0;
  padding: 0;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Link = styled.a`
  color: ${colorWhite2};
  font-size: 14px;
  line-height: 18px;
  transition: color 0.3s;

  &:hover,
  &:active {
    color: ${color4};
  }
`;
